// On touch screens there is no hover, so decorative hover states play when an item
// scrolls through the middle of the viewport instead. Desktop behaviour is untouched.
const SELECTOR = '[data-touch-reveal], .apart__item, .ing-card, .ritual-row, .steps-stats__item';
const ACTIVE = 'is-touch-active';

if (window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) entry.target.classList.toggle(ACTIVE, entry.isIntersecting);
    },
    { rootMargin: '-35% 0px -35% 0px' }
  );
  const watch = (root = document) => root.querySelectorAll(SELECTOR).forEach((el) => observer.observe(el));
  watch();
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
}
